import React, { useState, useEffect } from 'react';
import css from './CustomLandingPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import { injectIntl } from 'react-intl';
import FooterContainer from '../FooterContainer/FooterContainer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { logout } from '../../ducks/auth.duck';
import { currentUserListingSelector } from '../../ducks/user.duck';
import { isFinalStepCompletedForBriefs } from '../../util/genericHelpers';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { searchListings } from '../SearchPage/SearchPage.duck';
import { useConfiguration } from '../../context/configurationContext';
import { ListingCategory } from '../../util/enums';
import QuestionSection from './components/QuestionSection/QuestionSection';
import BottomPageBanner from '../../components/BottomPageBanner/BottomPageBanner';
import CustomNavbar from './components/CustomNavbar/CustomNavbar';
import NewHeroSection from './components/NewHeroSection/NewHeroSection';
import ForWhoSection from './components/ForWhoSection/ForWhoSection';
import MarketplaceSection from './components/MarketplaceSection/MarketplaceSection';
import PartnersSection from './components/PartnersSection/PartnersSection';
import ProjectBriefBanner from '../../components/ProjectBriefBanner/ProjectBriefBanner';
import PlanningRefMatchPopup from '../../components/PlanningRefMatchPopup/PlanningRefMatchPopup';

const CUSTOMER_USER_TYPES = ['selfBuilder', 'propertyDeveloper'];
const PROFESSIONAL_CATEGORIES = [
  ListingCategory.ARCHITECT_PROFESSIONAL,
  ListingCategory.HOUSE_BUILDER,
  ListingCategory.OFFSITE_SUPPLIER,
  ListingCategory.PROPERTY_DEVELOPER,
  ListingCategory.SELF_BUILDER,
];

const CustomLandingPageComponent = props => {
  const { currentUser, isAuthenticated, onLogout, intl, currentUserListing, isBriefComplete, listings, onFetchListings } = props;
  const config = useConfiguration();

  const [matchPopup, setMatchPopup] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem('leadflow_match_result');
      if (raw) {
        setMatchPopup(JSON.parse(raw));
        sessionStorage.removeItem('leadflow_match_result');
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    onFetchListings(config);
  }, [isAuthenticated]);

  const userType = currentUser?.attributes?.profile?.publicData?.userType;
  const userPlanningRef = currentUser?.attributes?.profile?.publicData?.planningReference;
  const listingPlanningRef = currentUserListing?.attributes?.publicData?.planningReference;
  const hasPlanningRef = !!(userPlanningRef || listingPlanningRef);
  const isCustomer = isAuthenticated && CUSTOMER_USER_TYPES.includes(userType);
  const showBriefBanner = isCustomer && !(isBriefComplete && hasPlanningRef);

  return (
    <Page
      title={intl.formatMessage({ id: 'CustomLandingPage.title' })}
      description={intl.formatMessage({ id: 'CustomLandingPage.description' })}
      scrollingDisabled={false}
    >
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        isLandingPage={true}
        topbar={
          <CustomNavbar
            currentUser={currentUser}
            isAuthenticated={isAuthenticated}
            onLogout={onLogout}
          />
        }
        footer={<FooterContainer isLandingPage={true} />}
      >
        {matchPopup && (
          <PlanningRefMatchPopup
            matched={matchPopup.matched}
            planningRef={matchPopup.planningRef}
            onDismiss={() => setMatchPopup(null)}
          />
        )}
        {showBriefBanner && <ProjectBriefBanner isComplete={isBriefComplete} hasPlanningRef={hasPlanningRef} />}
        <NewHeroSection />
        <ForWhoSection />
        <MarketplaceSection listings={listings} />
        <PartnersSection />
        <QuestionSection />
        <BottomPageBanner />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { isAuthenticated } = state.auth;
  const currentUserListing = currentUserListingSelector(state);
  const isBriefComplete = isFinalStepCompletedForBriefs(currentUserListing);
  const { currentPageResultIds } = state.SearchPage;
  const listings = getListingsById(state, currentPageResultIds);
  return { currentUser, isAuthenticated, currentUserListing, isBriefComplete,listings };
};

const mapDispatchToProps = dispatch => ({
  onLogout: historyPush => dispatch(logout(historyPush)),
  onFetchListings: config =>
    dispatch(
      searchListings(
        {
          page: 1,
          perPage: 24,
          pub_listingCategory: PROFESSIONAL_CATEGORIES.join(','),
          include: ['author', 'images'],
          'fields.listing': ['title', 'geolocation', 'price', 'publicData'],
          'fields.image': [
            'variants.default',
            'variants.scaled-small',
            'variants.listing-card',
            'variants.listing-card-2x',
          ],
          'limit.images': 1,
          minStock: 1,
          stockMode: 'match-undefined',
        },
        config
      )
    ),
});

const CustomLandingPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(CustomLandingPageComponent);

export default CustomLandingPage;
